webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.post = exports.get = undefined;

var _keys = __webpack_require__(129);

var _keys2 = _interopRequireDefault(_keys);

var _axios = __webpack_require__(42);

var _axios2 = _interopRequireDefault(_axios);

var _routes = __webpack_require__(43);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_axios2.default.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

var base = '/n/b';

var get = exports.get = function get(url, params) {
  return _axios2.default.get(base + '/' + url + '.json', { params: params }).then(function (res) {
    return res.data;
  }).catch(function (error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          var redirect = '/login?redirect=' + encodeURIComponent(window.location.href);
          _routes2.default.push(redirect);
          break;
        default:
          console.log(error.response);
      }
    } else {
      console.log(error);
    }
  });
};

var post = exports.post = function post(url, params) {
  var formData = new FormData();
  (0, _keys2.default)(params).forEach(function (key) {
    return formData.append(key, params[key]);
  });
  return _axios2.default.post(base + '/' + url + '.json', formData).then(function (res) {
    return res.data;
  }).catch(function (error) {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          var redirect = '/login?redirect=' + encodeURIComponent(window.location.href);
          _routes2.default.push(redirect);
          break;
        default:
          console.log(error.response);
      }
    } else {
      console.log(error);
    }
  });
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBackToYamb = exports.getBackToNforum = exports.searchBoards = exports.getSections = exports.getFavBoards = exports.getUser = exports.getProfile = exports.getReplyRead = exports.getAt = exports.getReply = exports.getTimeline = exports.getBanners = exports.getTopTen = undefined;

var _wrapper = __webpack_require__(6);

var getTopTen = exports.getTopTen = function getTopTen() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapper.get)('home/topten', params);
};

var getBanners = exports.getBanners = function getBanners() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapper.get)('banner', params);
};

var getTimeline = exports.getTimeline = function getTimeline() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapper.get)('home/timeline', params);
};

var getReply = exports.getReply = function getReply() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapper.get)('refer/reply', params);
};

var getAt = exports.getAt = function getAt() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapper.get)('refer/at', params);
};

var getReplyRead = exports.getReplyRead = function getReplyRead() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapper.get)('refer/reply', params);
};

var getProfile = exports.getProfile = function getProfile() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapper.get)('user/profile', params);
};

var getUser = exports.getUser = function getUser(id) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (0, _wrapper.get)('user/query/' + id, params);
};

var getFavBoards = exports.getFavBoards = function getFavBoards(level) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _wrapper.get)('home/fav/' + level, params);
};

var getSections = exports.getSections = function getSections() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _wrapper.get)('section', params);
};

var searchBoards = exports.searchBoards = function searchBoards() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { name: null };
  return (0, _wrapper.get)('section/' + params.name);
};

var getBackToNforum = exports.getBackToNforum = function getBackToNforum() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { name: null };
  return (0, _wrapper.get)('back-to-nforum');
};

var getBackToYamb = exports.getBackToYamb = function getBackToYamb() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { name: null };
  return (0, _wrapper.get)('back-to-yamb');
};

/***/ }),
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteMail = exports.forwardMail = exports.replyMail = exports.sendMail = exports.getMail = exports.getDeletedMailList = exports.getOutboxMailList = exports.getInboxMailList = exports.getMailList = undefined;

var _wrapper = __webpack_require__(6);

var getMailList = exports.getMailList = function getMailList(type, params) {
  return (0, _wrapper.get)('mail/' + type, params);
};
var getInboxMailList = exports.getInboxMailList = function getInboxMailList(params) {
  return (0, _wrapper.get)('mail/inbox', params);
};
var getOutboxMailList = exports.getOutboxMailList = function getOutboxMailList(params) {
  return (0, _wrapper.get)('mail/outbox', params);
};
var getDeletedMailList = exports.getDeletedMailList = function getDeletedMailList(params) {
  return (0, _wrapper.get)('mail/deleted', params);
};

var getMail = exports.getMail = function getMail(type, num, params) {
  return (0, _wrapper.get)('mail/' + type + '/show/' + num);
};

var sendMail = exports.sendMail = function sendMail(params) {
  return (0, _wrapper.post)('mail/send', params);
};

var replyMail = exports.replyMail = function replyMail(type, num, params) {
  return (0, _wrapper.post)('mail/' + type + '/send/' + num, params);
};

var forwardMail = exports.forwardMail = function forwardMail(type, num, params) {
  return (0, _wrapper.post)('mail/' + type + '/forward/' + num, params);
};

var deleteMail = exports.deleteMail = function deleteMail(type, num, params) {
  return (0, _wrapper.post)('mail/' + type + '/delete/' + num, params);
};

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(201)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(93),
  /* template */
  __webpack_require__(258),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-ea395d54",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueRouter = __webpack_require__(260);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _Home = __webpack_require__(220);

var _Home2 = _interopRequireDefault(_Home);

var _Auth = __webpack_require__(216);

var _Auth2 = _interopRequireDefault(_Auth);

var _Thread = __webpack_require__(229);

var _Thread2 = _interopRequireDefault(_Thread);

var _Board = __webpack_require__(217);

var _Board2 = _interopRequireDefault(_Board);

var _Section = __webpack_require__(228);

var _Section2 = _interopRequireDefault(_Section);

var _FavBoard = __webpack_require__(219);

var _FavBoard2 = _interopRequireDefault(_FavBoard);

var _Topten = __webpack_require__(231);

var _Topten2 = _interopRequireDefault(_Topten);

var _Profile = __webpack_require__(226);

var _Profile2 = _interopRequireDefault(_Profile);

var _Timeline = __webpack_require__(230);

var _Timeline2 = _interopRequireDefault(_Timeline);

var _Mail = __webpack_require__(221);

var _Mail2 = _interopRequireDefault(_Mail);

var _MailList = __webpack_require__(223);

var _MailList2 = _interopRequireDefault(_MailList);

var _MailContent = __webpack_require__(222);

var _MailContent2 = _interopRequireDefault(_MailContent);

var _MailSend = __webpack_require__(224);

var _MailSend2 = _interopRequireDefault(_MailSend);

var _Refer = __webpack_require__(227);

var _Refer2 = _interopRequireDefault(_Refer);

var _User = __webpack_require__(232);

var _User2 = _interopRequireDefault(_User);

var _Post = __webpack_require__(225);

var _Post2 = _interopRequireDefault(_Post);

var _Contributor = __webpack_require__(218);

var _Contributor2 = _interopRequireDefault(_Contributor);

var _store = __webpack_require__(44);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  mode: 'history',
  base: '/n/',
  routes: [{
    name: 'home',
    path: '/home',
    component: _Home2.default,
    meta: {
      requireLogin: true
    },

    children: [{
      name: 'topten',
      path: 'topten',
      component: _Topten2.default
    }, {
      name: 'fav',
      path: 'fav',
      component: _FavBoard2.default
    }, {
      name: 'section',
      path: '/section',
      component: _Section2.default,
      meta: {
        parent: 'fav'
      }
    }, {
      name: 'timeline',
      path: 'timeline',
      component: _Timeline2.default
    }, {
      name: 'profile',
      path: 'profile',
      component: _Profile2.default
    }]
  }, {
    name: 'auth',
    path: '/login',
    component: _Auth2.default
  }, {
    name: 'thread',
    path: '/article/:board/:id',
    component: _Thread2.default
  }, {
    name: 'board',
    path: '/board/:board/',
    component: _Board2.default,
    meta: {
      requireLogin: true
    }
  }, {
    name: 'post',
    path: '/post',
    component: _Post2.default,
    meta: {
      requireLogin: true
    }
  }, {
    name: 'mailSend',
    path: '/mail/send',
    component: _MailSend2.default
  }, {
    name: 'mail',
    path: '/mail',
    component: _Mail2.default,
    meta: {
      requireLogin: true
    },
    children: [{
      name: 'mailContent',
      path: ':type/show/:num',
      component: _MailContent2.default
    }, {
      name: 'mailList',
      path: ':type',
      component: _MailList2.default
    }]
  }, {
    name: 'reply',
    path: '/reply',
    component: _Refer2.default,
    meta: {
      requireLogin: true
    }
  }, {
    name: 'at',
    path: '/at',
    component: _Refer2.default,
    meta: {
      requireLogin: true
    }
  }, {
    name: 'user',
    path: '/user/:id',
    component: _User2.default,
    meta: {
      requireLogin: true
    }
  }, {
    name: 'contributor',
    path: '/contributor',
    component: _Contributor2.default,
    meta: {
      requireLogin: true
    }
  }, {
    name: '404',
    path: '/404',
    component: {
      template: '<div> 啊，这是哪儿？</div>'
    }
  }, {
    path: '*',
    redirect: '/home/topten'
  }]
});

router.beforeEach(function (to, from, next) {
  var isLogin = _store2.default.state.auth.isLogin;
  if (to.name == "Auth" && isLogin) {
    return next('/');
  }

  next();
});

exports.default = router;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vuex = __webpack_require__(15);

var _vuex2 = _interopRequireDefault(_vuex);

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _actions = __webpack_require__(125);

var actions = _interopRequireWildcard(_actions);

var _getters = __webpack_require__(126);

var getters = _interopRequireWildcard(_getters);

var _auth = __webpack_require__(51);

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var store = new _vuex2.default.Store({
    actions: actions,
    getters: getters,
    modules: {
        auth: _auth2.default
    },
    state: {},
    mutations: {}
});
exports.default = store;

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logout = exports.login = undefined;

var _wrapper = __webpack_require__(6);

var login = exports.login = function login(username, password) {
  return (0, _wrapper.post)('auth/login', { username: username, password: password });
};

var logout = exports.logout = function logout(username, password) {
  return (0, _wrapper.get)('auth/logout');
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(131);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _mutations;

var _mutationTypes = __webpack_require__(52);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  isLogin: false,
  user: {}
};

var mutations = (_mutations = {}, (0, _defineProperty3.default)(_mutations, _mutationTypes.LOGIN, function (state, user) {
  state.isLogin = true;
  state.user = user;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.LOGOUT, function (state, user) {
  state.user = {};
  state.isLogin = false;
}), (0, _defineProperty3.default)(_mutations, _mutationTypes.DECREASE_REFER, function (state) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'reply';

  var user = state.user;
  if (type == 'reply') {
    var c = user.new_reply > 0 ? user.new_reply : 1;
    user.new_reply = --c;
  } else if (type == 'at') {
    var _c = user.new_at > 0 ? user.new_at : 1;
    user.new_at = --_c;
  }
  state.user = user;
}), _mutations);

exports.default = {
  state: state,
  mutations: mutations
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOGIN = exports.LOGIN = "LOGIN";

var LOGOUT = exports.LOGOUT = "LOGOUT";

var DECREASE_REFER = exports.DECREASE_REFER = "DECREASE_REFER";

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(184)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(97),
  /* template */
  __webpack_require__(241),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b4ff446",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(27);

var _assign2 = _interopRequireDefault(_assign);

var _Toast = __webpack_require__(215);

var _Toast2 = _interopRequireDefault(_Toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Toast = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var preset = {
      duration: 2400,
      align: 'center',
      callback: null
    };
    (0, _assign2.default)(preset, options);

    Vue.prototype.$toast = function (message) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      (0, _assign2.default)(preset, options);

      var Tc = Vue.extend(_Toast2.default);
      var instance = new Tc().$mount(document.createElement('div'));

      instance.message = message;
      instance.visible = true;

      document.body.appendChild(instance.$el);

      setTimeout(function () {
        instance.visible = false;
        setTimeout(function () {
          document.body.removeChild(instance.$el);
          if (preset.callback) {
            preset.callback();
          }
        }, 500);
      }, preset.duration);
    };
  }
};

exports.default = Toast;

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(178)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(235),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Navbar = __webpack_require__(211);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _home = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',

  components: {
    Navbar: _Navbar2.default
  },

  data: function data() {
    return {
      year: new Date().getFullYear()
    };
  },
  mounted: function mounted() {
    (0, _home.getBackToYamb)();
  },


  methods: {
    backToNforum: function backToNforum() {
      var _this = this;

      (0, _home.getBackToNforum)().then(function (res) {
        if (!res.success) {
          return _this.$toast(res.message);
        }
        window.location.href = "/";
      });
    }
  }

};

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'feed',
  props: ['title', 'desciption', 'author', 'board', 'attachment', 'linker', 'backgroundColor']
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'FloatButton',

  data: function data() {
    return {
      visible: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    var timer = null;
    window.addEventListener('scroll', function () {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        _this.visible = true;
      }, 300);
      if (_this.visible) {
        _this.visible = false;
      }
    });
  }
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: "mailitem",
  props: ["read", "num", "sender", "title", "time", "size", "linker"]
};

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(17);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'Navbar',

  data: function data() {
    return {
      menuActive: false
    };
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['profile'])),

  methods: {}

};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _betterScroll = __webpack_require__(133);

var _betterScroll2 = _interopRequireDefault(_betterScroll);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NAME = 'picker';
var EVENT_CHANGE = 'change';

exports.default = {
  name: NAME,

  data: function data() {
    return {
      visible: false,
      selectedIndex: null,
      dataItems: [],
      wheel: null
    };
  },


  props: {
    data: {
      type: Array,
      required: true
    }
  },

  watch: {
    data: function data(newData) {
      this.setData(newData);
    }
  },

  methods: {
    show: function show() {
      if (this.visible) {
        return true;
      }

      this.visible = true;

      if (!this.wheel) {
        this.wheel = this._createWheel(this.$refs.pickerWheel);
      } else {
        this.wheel.enable();
      }
    },
    hide: function hide() {
      if (!this.visible) {
        return true;
      }

      this.visible = false;

      this.wheel.disable();
    },
    canConfirm: function canConfirm() {
      return this.wheel && !this.wheel.isInTransition;
    },
    setData: function setData(data) {
      var _this = this;

      this.dataItems = data;
      if (this.visible) {
        this.$nextTick(function () {
          _this.wheel.refresh();
        });
      }
    },
    _createWheel: function _createWheel(wrapper) {
      var _this2 = this;

      var wheel = new _betterScroll2.default(wrapper, {
        wheel: {
          selectedIndex: 0
        }
      });

      wheel.on('scrollEnd', function () {
        var v = _this2.dataItems[wheel.getSelectedIndex()];
        _this2.$emit(EVENT_CHANGE, v);
      });

      return wheel;
    }
  }
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'ReplyFloatButton',

  data: function data() {
    return {
      visible: true
    };
  },
  mounted: function mounted() {
    var _this = this;

    var timer = null;
    window.addEventListener('scroll', function () {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(function () {
        _this.visible = true;
      }, 300);
      if (_this.visible) {
        _this.visible = false;
      }
    });
  }
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isInteger = __webpack_require__(127);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _fav = __webpack_require__(120);

var api = _interopRequireWildcard(_fav);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'SectionCard',

  props: {
    section: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      isOpen: false
    };
  },
  created: function created() {},


  methods: {
    toggle: function toggle() {
      if (!this.isOpen && !this.section.children.length) {
        return this.$toast('该分区无任何版面');
      }
      this.isOpen = !this.isOpen;
    },
    sectionColor: function sectionColor(id) {
      if (!(0, _isInteger2.default)(id)) {
        id = id[0].charCodeAt() % 10;
      }
      return 'color-' + id;
    },
    opFav: function opFav(section) {
      var _this = this;

      if (section.dir) return;

      var action = null;
      if (section.fav) {
        action = 'db';
      } else {
        action = 'ab';
      }
      api.opFav({
        ac: action,
        v: section.id
      }).then(function (res) {
        if (res.success) {
          if (action == 'ab') {
            _this.section.fav = true;
            return _this.$toast('收藏成功');
          } else if (action == 'db') {
            _this.section.fav = false;
            return _this.$toast('取消收藏成功');
          } else {}
        }
      });
    }
  }
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'slider',

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      ready: false,
      width: 0,
      height: 0,

      activeIndex: 0,
      oldActiveIndex: 0,

      timer: 0,
      interval: 3000
    };
  },
  mounted: function mounted() {
    this.width = screen.width - 4;
    this.height = this.width * .25;
    this.startTimer();
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },


  methods: {
    startTimer: function startTimer() {
      if (this.timer) return;
      this.timer = setInterval(this.play, this.interval);
      if (!this.ready) {
        this.ready = true;
      }
    },
    play: function play() {
      this.oldActiveIndex = this.activeIndex;
      if (this.activeIndex < this.items.length - 1) {
        this.activeIndex++;
      } else {
        this.activeIndex = 0;
      }
    },
    isAnimating: function isAnimating(index) {
      return index == this.oldActiveIndex || index == this.activeIndex;
    },
    calculatetranslate: function calculatetranslate(index) {
      if (Math.abs(this.activeIndex - index) == this.items.length - 1) {
        return this.activeIndex > index ? this.width : -this.width;
      }
      return (index - this.activeIndex) * this.width;
    },
    clickItem: function clickItem(item) {
      window.location.href = item.url;
    },
    delayed: function delayed(index) {
      return 5 * index;
    }
  }

};

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'toast',

  data: function data() {
    return {
      visible: false,
      message: ''
    };
  }
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(17);

var _extends3 = _interopRequireDefault(_extends2);

var _auth = __webpack_require__(50);

var api = _interopRequireWildcard(_auth);

var _vuex = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      show: false,
      username: '',
      password: '',
      error: false,
      year: new Date().getFullYear()
    };
  },
  created: function created() {
    if (this.profile.isLogin) {
      return this.$route.push('/');
    }
    this.show = true;
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['profile'])),

  methods: (0, _extends3.default)({
    doLogin: function doLogin() {
      var _this = this;

      api.login(this.username, this.password).then(function (res) {
        if (!res.success) {
          _this.error = true;
        } else {
          _this.login(res.data);
          _this.error = false;
          if (_this.$route.query.redirect) {
            var target = decodeURIComponent(_this.$route.query.redirect);
            if (target.match('login')) {
              _this.$router.push('/');
            } else {
              window.location.href = target;
            }
          } else {
            _this.$router.push('/');
          }
        }
      });
    }
  }, (0, _vuex.mapActions)(['login']))

};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _board = __webpack_require__(119);

var api = _interopRequireWildcard(_board);

var _Picker = __webpack_require__(71);

var _Picker2 = _interopRequireDefault(_Picker);

var _FloatButton = __webpack_require__(209);

var _FloatButton2 = _interopRequireDefault(_FloatButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      query: {
        board: null
      },

      isLoading: true,
      showAllTopPosts: false,

      currentPage: 1,
      totalPage: 1,
      pagePickerData: [],
      pagePickerVisible: false,

      canPost: false,
      isAdmin: false,
      isBM: false,
      name: '',
      description: '',

      posts: [],
      topPosts: [],
      cachedPages: {}
    };
  },


  components: {
    Picker: _Picker2.default,
    FloatButton: _FloatButton2.default
  },

  created: function created() {
    this.query = this.$route.params;
    this.fetchBoards();
  },


  methods: {
    fetchBoards: function fetchBoards() {
      var _this = this;

      this.isLoading = true;
      var page = this.currentPage;
      if (page in this.cachedPages) {
        this.isLoading = false;
        return this.posts = this.cachedPages[page];
      }

      api.getBoard(this.query.board, { page: page }).then(function (res) {
        if (!res.success) {
          return false;
        }

        var data = res.data;
        _this.name = data.name;
        _this.description = data.description;
        _this.totalPage = data.pagination.total;
        _this.canPost = data.canPost;
        _this.isAdmin = data.Admin;
        _this.isBM = data.isBM;

        _this.topPosts = [];_this.posts = [];
        for (var i in data.posts) {
          if (data.posts[i].tag == 'top') {
            _this.topPosts.push(data.posts[i]);
          } else {
            _this.posts.push(data.posts[i]);
          }
        }

        document.body.scrollTop = document.documentElement.scrollTop = 0;

        _this.isLoading = false;

        _this.pagePickerData = [].concat((0, _toConsumableArray3.default)(Array(_this.totalPage).keys())).map(function (i) {
          return {
            value: i + 1,
            label: '第' + (i + 1) + '页'
          };
        });

        _this.$nextTick(function () {
          _this.$refs.pagePicker.setData(_this.pagePickerData);
        });
      });
    },
    getArticle: function getArticle(gid) {
      return '/article/' + this.name + '/' + gid;
    },
    getPrevPage: function getPrevPage() {
      if (this.currentPage <= 1) {
        return false;
      }
      this.currentPage--;
      this.fetchBoards();
    },
    getNextPage: function getNextPage() {
      if (this.currentPage >= this.totalPage) {
        return false;
      }
      this.currentPage++;
      this.fetchBoards();
    },
    hidePagePicker: function hidePagePicker() {
      this.pagePickerVisible = false;
      this.$refs.pagePicker.hide();
    },
    showPagePicker: function showPagePicker() {
      console.log('asdf');
      this.pagePickerVisible = true;
      this.$refs.pagePicker.show();
    },
    pageChanged: function pageChanged(page) {
      this.selectedPage = page.value;
    },
    getSelectedPage: function getSelectedPage() {
      if (!this.$refs.pagePicker.canConfirm()) {
        return;
      }

      this.hidePagePicker();
      this.currentPage = this.selectedPage;
      this.fetchBoards();
    },
    getFirstPage: function getFirstPage() {
      this.hidePagePicker();
      this.currentPage = 1;
      this.fetchBoards();
    },
    getLastPage: function getLastPage() {
      this.hidePagePicker();
      this.currentPage = this.totalPage;
      this.fetchBoards();
    },
    newPost: function newPost() {
      var url = '/post?type=new&board=' + this.query.board;
      this.$router.push(url);
    }
  }
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      contributors: [{
        id: 'D7474126',
        work: '回复/艾特 设计与编码'
      }, {
        id: 'raaay0608',
        work: '站内信 设计与编码'
      }, {
        id: 'OnlySaturday',
        work: '分区 前后端设计与编码'
      }]
    };
  }
};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _home = __webpack_require__(7);

var api = _interopRequireWildcard(_home);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      level: 0,
      isLoading: true,
      parent: -1,
      boards: []
    };
  },
  created: function created() {
    this.level = this.$route.query.level ? this.$route.query.level : 0;
    this.fetchBoards();
  },


  methods: {
    fetchBoards: function fetchBoards() {
      var _this = this;

      this.isLoading = true;
      api.getFavBoards(this.level).then(function (res) {
        if (!res.success) {
          _this.$toast(res.message);
          return false;
        }
        var data = res.data;
        _this.boards = data.boards;
        _this.parent = data.parent;
        _this.isLoading = false;
      });
    },
    jumpToBoard: function jumpToBoard(board) {
      if (!board.dir) {
        return this.$router.push('/board/' + board.name);
      }

      this.level = board.level;
      this.fetchBoards();
    },
    jumpToSection: function jumpToSection() {
      this.$router.push('/section');
    },
    getParent: function getParent() {
      this.level = this.parent;
      this.fetchBoards();
    }
  }

};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'home',

  data: function data() {
    return {
      navActived: {
        topten: true,
        timeline: false,
        fav: false,
        profile: false
      }
    };
  },


  watch: {
    $route: function $route(to, from) {
      var activeTab = to.meta.parent ? to.meta.parent : to.name;
      this.changeTab(activeTab);
    }
  },

  created: function created() {
    var activeTab = this.$route.meta.parent ? this.$route.meta.parent : this.$route.name;
    if (activeTab == 'home') {
      return this.$router.push('/home/topten');
    }
    this.changeTab(activeTab);
  },


  methods: {
    changeTab: function changeTab(active) {
      if (active == 'home') {
        active = 'topten';
      }
      for (var key in this.navActived) {
        if (key == active) {
          this.navActived[key] = true;
        } else {
          this.navActived[key] = false;
        }
      }
    },
    navClicked: function navClicked(item) {
      this.changeTab(item);
      this.$router.push('/home/' + item);
    }
  }
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      mailTabActivated: {
        inbox: true,
        outbox: false,
        deleted: false
      }
    };
  },
  created: function created() {
    this.changeMailTab(this.$route.params.type);
  },


  methods: {
    mailTabClicked: function mailTabClicked(type) {
      this.changeMailTab(type);
      this.$router.push({ name: "mailList", params: { type: type } });
    },
    changeMailTab: function changeMailTab(type) {
      for (var key in this.mailTabActivated) {
        this.mailTabActivated[key] = key === type;
      }
    }
  }
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(29);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(28);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mail = __webpack_require__(26);

var api = _interopRequireWildcard(_mail);

var _ReplyFloatButton = __webpack_require__(212);

var _ReplyFloatButton2 = _interopRequireDefault(_ReplyFloatButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      mail: {
        num: "",
        title: "",
        sender: "",
        time: "",
        content: ""
      },

      modalActive: {
        replyModal: false,
        forwardModal: false,
        deleteModal: false
      },

      replyForm: {
        isTitleDanger: false,
        isContentDanger: false,
        title: "",
        content: ""
      },

      forwardForm: {
        isTargetUserDanger: false,
        targetUser: ""
      },

      isLoading: true,

      error: false,
      errorMessage: ""
    };
  },


  computed: {
    mailType: function mailType() {
      return this.$route.params.type;
    },
    mailNum: function mailNum() {
      return this.$route.params.num;
    }
  },

  components: {
    FloatButton: _ReplyFloatButton2.default
  },

  created: function created() {
    this.fetchMail();
  },


  methods: {
    fetchMail: function fetchMail() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _context.next = 3;
                return api.getMail(_this.mailType, _this.mailNum);

              case 3:
                res = _context.sent;

                if (res.success) {
                  _context.next = 9;
                  break;
                }

                _this.error = true;
                _this.$toast("Oops, there is an error...");
                _this.isLoading = false;
                return _context.abrupt("return", false);

              case 9:
                _this.error = false;

                _this.mail.num = res.data.num;
                _this.mail.title = res.data.title;
                _this.mail.sender = res.data.sender;
                _this.mail.time = res.data.time;
                _this.mail.content = res.data.content;
                _this.replyForm.title = _this.mail.title.startsWith("Re: ") ? _this.mail.title : "Re: " + _this.mail.title;
                _this.isLoading = false;

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    reply: function reply() {
      this.$router.push({
        name: "mailSend",
        query: {
          action: "reply",
          to: this.mail.sender,
          title: this.mail.title.startsWith("Re: ") ? this.mail.title : "Re: " + this.mail.title,
          type: this.mailType,
          num: this.mailNum
        }
      });
    }
  }
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(29);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(28);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _mail = __webpack_require__(26);

var api = _interopRequireWildcard(_mail);

var _MailItem = __webpack_require__(210);

var _MailItem2 = _interopRequireDefault(_MailItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isLoading: true,
      currentPage: 1,
      totalPage: 0,
      mails: []
    };
  },


  computed: {
    type: function type() {
      return this.$route.params.type;
    },
    notification: function notification() {
      return this.$route.query.notification;
    },
    isFirstPage: function isFirstPage() {
      return this.currentPage <= 1;
    },
    isLastPage: function isLastPage() {
      return this.currentPage >= this.totalPage;
    }
  },

  components: {
    MailItem: _MailItem2.default
  },

  watch: {
    "$route.params.type": function $routeParamsType(newType, oldType) {
      this.mails = [];
      this.currentPage = 1;
      this.fetchMailList(newType);
    }
  },

  created: function created() {
    this.fetchMailList();
    if (this.notification) {
      this.$toast(this.notification);
    }
  },


  methods: {
    fetchMailList: function fetchMailList() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.isLoading = true;
                _context.next = 3;
                return api.getMailList(_this.type, {
                  page: _this.currentPage
                });

              case 3:
                res = _context.sent;

                _this.isLoading = false;

                if (res.success) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", false);

              case 7:
                _this.mails = res.data.mails;
                _this.currentPage = res.data.pagination.current;
                _this.totalPage = res.data.pagination.total;
                _this.top();

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    top: function top() {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    },
    changePage: function changePage(page) {
      if (page < 1 || page > this.totalPage) {
        return false;
      }
      this.currentPage = page;
      this.fetchMailList();
    },
    mailLinker: function mailLinker(mailItem) {
      return "/mail/" + this.type + "/show/" + mailItem.num;
    }
  }
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__(29);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(28);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _mail = __webpack_require__(26);

var api = _interopRequireWildcard(_mail);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      pageLoading: false,
      attachment: true,
      type: "new",
      title: "",
      content: "",
      to: "",
      showSmileBox: false,
      activeSmileSuite: "em",
      smiles: [{
        name: "em",
        size: "32x32",
        serials: [].concat((0, _toConsumableArray3.default)(Array(73).keys())).map(function (n) {
          return n + 1;
        })
      }, {
        name: "ema",
        size: "48x48",
        serials: [].concat((0, _toConsumableArray3.default)(Array(42).keys()))
      }, {
        name: "emb",
        size: "48x48",
        serials: [].concat((0, _toConsumableArray3.default)(Array(25).keys()))
      }, {
        name: "emc",
        size: "48x48",
        serials: [].concat((0, _toConsumableArray3.default)(Array(53).keys()))
      }],

      showUploadBox: true,
      showUploadLoader: false,
      uploadItems: [],
      files: []
    };
  },
  created: function created() {
    this.query = this.$route.query;
    this.action = this.query.action;
    this.title = this.query.title;
    this.to = this.query.to;
  },
  mounted: function mounted() {
    this.pageLoading = false;
  },


  methods: {
    expandSmileBox: function expandSmileBox() {
      this.showSmileBox = this.showSmileBox ? false : true;
    },
    clickSmileSuite: function clickSmileSuite(name) {
      this.activeSmileSuite = name;
    },
    insertSmile: function insertSmile(name, i) {
      this.content += "[" + name + i + "]";
    },
    onSend: function onSend() {
      switch (this.action) {
        case "reply":
          this.replyMail();
          break;
        case "new":
          this.sendMail();
          break;
        default:
          this.$toast("参数错误");
      }
    },
    sendMail: function sendMail() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var data, res;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = {
                  title: _this.title,
                  content: _this.content,
                  id: _this.query.to
                };

                if (!(!data.id || !data.title || !data.content)) {
                  _context.next = 5;
                  break;
                }

                _this.pageLoading = false;
                if (!data.id) _this.$toast("Oops，忘记要发给谁了...返回上级重进此页面试一下？");else if (!data.title) _this.$toast("Oops，标题不能为空");else if (!data.content) _this.$toast("Oops，内容不能为空");
                return _context.abrupt("return", false);

              case 5:
                _context.next = 7;
                return api.sendMail(data);

              case 7:
                res = _context.sent;

                _this.pageLoading = false;

                if (res.success) {
                  _context.next = 12;
                  break;
                }

                _this.$toast("发送失败...");
                return _context.abrupt("return", false);

              case 12:
                _this.$toast("发送成功", {
                  duration: 800,
                  callback: function callback() {
                    _this.$router.go(-1);
                  }
                });

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    replyMail: function replyMail() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var data, res;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = {
                  title: _this2.title,
                  content: _this2.content
                };

                if (!(!data.title || !data.content)) {
                  _context2.next = 5;
                  break;
                }

                _this2.pageLoading = false;
                if (!data.title) _this2.$toast("Oops，标题不能为空");else if (!data.content) _this2.$toast("Oops，内容不能为空");
                return _context2.abrupt("return", false);

              case 5:
                _context2.next = 7;
                return api.replyMail(_this2.query.type, _this2.query.num, data);

              case 7:
                res = _context2.sent;

                if (res.success) {
                  _context2.next = 11;
                  break;
                }

                _this2.$toast("发送失败...");
                return _context2.abrupt("return", false);

              case 11:
                _this2.$toast("发送成功", {
                  duration: 800,
                  callback: function callback() {
                    _this2.$router.go(-1);
                  }
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    }
  }
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _post = __webpack_require__(121);

var api = _interopRequireWildcard(_post);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      pageLoading: false,
      attachment: false,
      attachmentSize: 0,
      type: 'new',

      board: '',

      reid: null,
      reTitle: '',

      id: null,
      originalAttachments: [],
      deletedAttachments: [],

      attachInputBinded: false,
      attachInput2Binded: false,

      title: '',
      content: '',
      showSmileBox: false,
      activeSmileSuite: 'em',
      smiles: [{
        name: 'em',
        size: '32x32',
        serials: [].concat((0, _toConsumableArray3.default)(Array(73).keys())).map(function (n) {
          return n + 1;
        })
      }, {
        name: 'ema',
        size: '48x48',
        serials: [].concat((0, _toConsumableArray3.default)(Array(42).keys()))
      }, {
        name: 'emb',
        size: '48x48',
        serials: [].concat((0, _toConsumableArray3.default)(Array(25).keys()))
      }, {
        name: 'emc',
        size: '48x48',
        serials: [].concat((0, _toConsumableArray3.default)(Array(53).keys()))
      }],

      showUploadBox: true,
      showUploadLoader: false,
      uploadItems: [],
      files: []

    };
  },
  created: function created() {
    var query = this.$route.query;
    if (!query.board) {
      return this.$router.push('/404');
    }
    this.board = query.board;
    if (query.type == 'reply') {
      if (!query.reid) {
        return this.$router.push('/404');
      }
      this.reid = query.reid;
      this.type = 'reply';
      this.reTitle = query.retitle ? decodeURIComponent(query.retitle) : '';
      this.title = "Re: " + this.reTitle;
    } else if (query.type == 'edit') {
      this.type = 'edit';
      this.id = query.id;
    } else {
      this.type = 'new';
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.pageLoading = true;
    switch (this.type) {
      case 'reply':
        api.preReply(this.board, this.reid).then(function (res) {
          _this.pageLoading = false;
          if (res.success) {
            _this.attachment = res.data.attachment;
            if (_this.attachment) {
              _this.$nextTick(function () {
                if (!_this.attachInputBinded) {
                  _this.bindUploadEvent('attachment');
                  _this.attachInputBinded = true;
                }
              });
            }
            return true;
          }
          _this.$toast(res.message, {
            callback: function callback() {
              _this.$router.go(-1);
            }
          });
        });
        break;

      case 'edit':
        api.getEdit(this.board, this.id).then(function (res) {
          _this.pageLoading = false;
          if (!res.success) {
            return _this.$toast(res.message, {
              callback: function callback() {
                _this.$router.go(-1);
              }
            });
          }

          _this.title = res.data.title;
          _this.content = res.data.content;
          if (res.data.attachments.length) {
            _this.originalAttachments = res.data.attachments;
            res.data.attachments.forEach(function (item) {
              _this.uploadItems.push('/att/' + _this.board + '/' + _this.id + '/' + item.pos);
              _this.attachmentSize += item.size;
            });
          }
          if (res.data.attachment) {
            _this.attachment = true;
            _this.$nextTick(function () {
              if (!_this.attachInputBinded) {
                _this.bindUploadEvent('attachment');
                _this.attachInputBinded = true;
              }
              if (!_this.attachInput2Binded) {
                _this.bindUploadEvent('attachment2');
                _this.attachInput2Binded = true;
              }
            });
          }
        });

        break;

      case 'new':
        api.prePost(this.board).then(function (res) {
          _this.pageLoading = false;
          if (res.success) {
            _this.attachment = res.data.attachment;
            if (_this.attachment) {
              _this.$nextTick(function () {
                if (!_this.attachInputBinded) {
                  _this.bindUploadEvent('attachment');
                  _this.attachInputBinded = true;
                }
              });
            }
            return true;
          }
          _this.$toast(res.message, {
            callback: function callback() {
              _this.$router.go(-1);
            }
          });
        });

        break;
    }
  },


  methods: {
    expandSmileBox: function expandSmileBox() {
      this.showSmileBox = this.showSmileBox ? false : true;
    },
    bindUploadEvent: function bindUploadEvent(id) {
      var _this2 = this;

      var $file = document.getElementById(id);
      this.showSmileBox = false;
      $file.addEventListener('change', function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          _this2.uploadItems.push(reader.result);
          _this2.insertImage();
          if (_this2.uploadItems.length == 1) {
            if (!_this2.attachInput2Binded) {
              _this2.bindUploadEvent('attachment2');
              _this2.attachInput2Binded = true;
            }
          }
          _this2.showUploadLoader = false;
        };

        var file = $file.files[0];
        if (!file) {
          return false;
        }

        if (_this2.attachmentSize + file.size > 5242880) {
          _this2.$toast('图片大小不能超过5Mb');
          return false;
        }

        if (_this2.uploadItems.length >= 20) {
          _this2.$toast('附件数量不能超过20个');
          return false;
        }

        _this2.attachmentSize += file.size;
        _this2.files.push(file);
        _this2.showUploadLoader = true;
        reader.readAsDataURL(file);
      }, true);
    },
    clickSmileSuite: function clickSmileSuite(name) {
      this.activeSmileSuite = name;
    },
    insertSmile: function insertSmile(name, i) {
      this.content += '[' + name + i + ']';
    },
    insertMention: function insertMention() {
      this.content += '@';
    },
    insertImage: function insertImage() {
      var tag = '[upload=' + this.uploadItems.length + '][/upload]';

      this.content += tag;
    },
    removeImage: function removeImage(index) {
      var tag = '[upload=' + (index + 1) + '][/upload]';
      var url = this.uploadItems[index];
      this.uploadItems.splice(index, 1);
      if (!url.startsWith('/att')) {
        this.files.splice(index, 1);
      } else {
        var pos = url.split('/').pop();
        for (var i in this.originalAttachments) {
          if (this.originalAttachments[i].pos == pos) {
            this.deletedAttachments.push(this.originalAttachments[i]['name']);
          }
        }
      }
      this.content = this.content.replace(tag, '');
    },
    post: function post() {
      var _this3 = this;

      this.pageLoading = true;

      var addAtt = function addAtt() {
        var _loop = function _loop(i) {
          api.addAttachment(_this3.board, _this3.files[i], _this3.id ? _this3.id : null).then(function (response) {
            if (!response.success) {
              _this3.pageLoading = false;
              return _this3.$toast(response.message);
            }
            if (i == _this3.files.length - 1) {
              _this3.postArticle();
            }
          });
        };

        for (var i in _this3.files) {
          _loop(i);
        }
      };

      if (!this.deletedAttachments.length) {
        if (this.files.length == 0) {
          this.postArticle();
        } else {
          addAtt();
        }
        return true;
      }

      var _loop2 = function _loop2(i) {
        api.deleteAttachment(_this3.board, _this3.deletedAttachments[i], _this3.id).then(function (response) {
          if (!response.success) {
            _this3.pageLoading = false;
            return _this3.$toast(response.message);
          }
          if (i == _this3.deletedAttachments.length - 1) {
            if (_this3.files.length == 0) {
              _this3.postArticle();
            } else {
              addAtt();
            }
          }
        });
      };

      for (var i in this.deletedAttachments) {
        _loop2(i);
      }
    },
    postArticle: function postArticle() {
      var _this4 = this;

      var data = {
        subject: this.title,
        content: this.content
      };
      switch (this.type) {
        case 'new':
          api.newArticle(this.board, data).then(function (response) {
            _this4.pageLoading = false;
            if (response.success) {
              _this4.pageLoading = false;
              return _this4.$router.go(-1);
            }
            _this4.$toast(response.message);
          });
          break;

        case 'reply':
          api.replyArticle(this.board, this.reid, data).then(function (response) {
            _this4.pageLoading = false;
            if (response.success) {
              _this4.pageLoading = false;
              return _this4.$router.go(-1);
            }
            _this4.$toast(response.message);
          });
          break;

        case 'edit':
          api.editArticle(this.board, this.id, data).then(function (response) {
            _this4.pageLoading = false;
            if (response.success) {
              _this4.pageLoading = false;
              return _this4.$router.go(-1);
            }
            _this4.$toast(response.message);
          });

          break;

        default:
          break;
      }

      return true;
    }
  }
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(17);

var _extends3 = _interopRequireDefault(_extends2);

var _vuex = __webpack_require__(15);

var _home = __webpack_require__(7);

var api = _interopRequireWildcard(_home);

var _auth = __webpack_require__(50);

var authApi = _interopRequireWildcard(_auth);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isLoading: true
    };
  },
  created: function created() {
    this.fetchProfile();
  },


  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)(['profile'])),

  methods: (0, _extends3.default)({
    fetchProfile: function fetchProfile() {
      var _this = this;

      if (this.profile.isLogin) {
        return;
      }
      this.isLoading = true;
      api.getProfile().then(function (res) {
        if (res.success) {
          _this.login(res.data);
          _this.isLoading = false;
        }
      });
    },
    getLogout: function getLogout() {
      var _this2 = this;

      authApi.logout().then(function (res) {
        if (res.success) {
          _this2.logout();
          _this2.$router.push('/login');
        }
      });
    }
  }, (0, _vuex.mapActions)(['login', 'logout']))
};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(17);

var _extends3 = _interopRequireDefault(_extends2);

var _refer = __webpack_require__(122);

var api = _interopRequireWildcard(_refer);

var _Feed = __webpack_require__(41);

var _Feed2 = _interopRequireDefault(_Feed);

var _vuex = __webpack_require__(15);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isLoading: true,
      type: '',
      feeds: []
    };
  },


  components: {
    Feed: _Feed2.default
  },

  created: function created() {
    var route = this.$route;
    this.type = route.name;
    this.fetchRefer(this.page);
  },


  methods: (0, _extends3.default)({
    fetchRefer: function fetchRefer(page) {
      var _this = this;

      this.isLoading = true;
      api.getRefer(this.type, { page: page }).then(function (res) {
        if (!res.success) {
          return false;
        }

        _this.feeds = _this.feeds.concat(res.data.article);
        _this.isLoading = false;
      });
    },
    setRead: function setRead(feed) {
      var _this2 = this;

      if (feed.read) {
        return true;
      }
      var index = feed.index;
      api.setRead(this.type, { index: index }).then(function (res) {
        if (res.success) {
          feed.read = true;
          _this2.decreaseRefer(_this2.type);
        }
      });
    },
    replyLinker: function replyLinker(feed) {
      return '/article/' + feed.board + '/' + feed.group_id + "?pos=" + feed.pos;
    }
  }, (0, _vuex.mapActions)(['decreaseRefer']))
};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _home = __webpack_require__(7);

var api = _interopRequireWildcard(_home);

var _SectionCard = __webpack_require__(213);

var _SectionCard2 = _interopRequireDefault(_SectionCard);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isLoading: true,
      doms: {},
      search_content: '',
      boards: []
    };
  },


  components: {
    SectionCard: _SectionCard2.default
  },

  created: function created() {
    this.fetchSections();
  },


  methods: {
    fetchSections: function fetchSections() {
      var _this = this;

      this.isLoading = true;
      api.getSections().then(function (res) {
        if (!res.success) {
          return false;
        }
        var data = res.data;
        _this.boards = data.boards;
        _this.isLoading = false;
      });
    },
    searchBoard: function searchBoard() {
      var _this2 = this;

      if (this.search_content.trim() == '') {
        this.boards = [];
        return this.fetchSections();
      }
      this.isLoading = true;
      api.searchBoards({ name: this.search_content }).then(function (res) {
        if (!res.success) {
          return false;
        }

        _this2.boards = res.data.boards;
        _this2.isLoading = false;
      });
    }
  }
};

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toArray2 = __webpack_require__(132);

var _toArray3 = _interopRequireDefault(_toArray2);

var _toConsumableArray2 = __webpack_require__(18);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _thread = __webpack_require__(123);

var api = _interopRequireWildcard(_thread);

var _Picker = __webpack_require__(71);

var _Picker2 = _interopRequireDefault(_Picker);

var _marked = __webpack_require__(204);

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      query: {
        board: '',
        id: ''
      },

      position: null,

      isLoading: true,

      title: '加载中...',
      time: '',
      gid: 0,
      board: {
        description: 'loading',
        name: '...'
      },

      currentPage: 1,
      totalPage: 1,

      anony: false,

      mainPost: null,
      posts: [],
      popularReplies: [],
      cachePosts: {},

      pagePickerVisible: false,
      pagePickerData: [],
      selectedPage: 1,

      showVoteChoice: false,

      removeSelected: false
    };
  },


  components: {
    Picker: _Picker2.default
  },

  watch: {},

  created: function created() {
    var location = this.$route.query;
    if (location.page) {
      this.currentPage = location.page;
    }

    if (location.pos) {
      this.currentPage = parseInt(location.pos / 10) + 1;
      this.position = location.pos;
    }

    this.query = this.$route.params;
    this.fetchArticles();
  },


  methods: {
    fetchArticles: function fetchArticles() {
      var _this = this;

      this.isLoading = true;
      var page = this.currentPage;
      if (page in this.cachePosts) {
        this.isLoading = false;
        return this.posts = this.cachePosts[page];
      }
      api.getThread(this.query.board, this.query.id, { page: page }).then(function (res) {
        if (!res.success) {
          return false;
        }

        var data = res.data;
        _this.title = data.title;
        _this.time = data.time;
        _this.gid = data.gid;
        _this.board = data.board;
        _this.anony = data.anony;
        _this.popularReplies = data.popularReplies;
        _this.totalPage = data.pagination.total;

        _this.pagePickerData = [].concat((0, _toConsumableArray3.default)(Array(_this.totalPage).keys())).map(function (i) {
          return {
            value: i + 1,
            label: '第' + (i + 1) + '页'
          };
        });

        var postContent = document.createElement('div');
        for (var i = 0; i < data.articles.length; ++i) {
          postContent.innerHTML = data.articles[i].content;
          var markdownNode = postContent.querySelectorAll('pre.markdown');
          for (var j = 0; j < markdownNode.length; ++j) {
            markdownNode[j].outerHTML = (0, _marked2.default)(markdownNode[j].innerText);
          }
          data.articles[i].content = postContent.innerHTML;
        }


        if (data.articles[0]['id'] == _this.gid) {
          var _data$articles = (0, _toArray3.default)(data.articles);

          _this.mainPost = _data$articles[0];
          _this.posts = _data$articles.slice(1);
        } else {
          _this.posts = data.articles;
          if (data.head && !_this.mainPost) {
            _this.mainPost = data.head;
          }

          if (!_this.mainPost && _this.currentPage == 1) {
            _this.posts.map(function (article) {
              return article.pos++;
            });
          }
        }

        document.title = _this.title + ' -北邮人论坛';
        _this.cachePosts[page] = _this.posts;
        document.body.scrollTop = document.documentElement.scrollTop = 0;

        _this.isLoading = false;
        _this.$nextTick(function () {
          _this.$refs.pagePicker.setData(_this.pagePickerData);
        });

        if (_this.position > 0) {
          _this.$nextTick(function () {
            var $dom = document.getElementById(_this.position);
            if (!$dom) {
              return;
            }

            $dom.scrollIntoView();
            setTimeout(function () {
              _this.removeSelected = true;
            }, 2000);
          });
        }
      });
    },
    jumpToBoard: function jumpToBoard(name) {
      this.$router.push('/board/' + name);
    },
    jumpToUser: function jumpToUser(article) {
      if (article.poster) {
        this.$router.push('/user/' + article.poster.id);
      }
    },
    getPrevPage: function getPrevPage() {
      if (this.currentPage <= 1) {
        return false;
      }
      this.currentPage--;
      this.fetchArticles();
    },
    getNextPage: function getNextPage() {
      if (this.currentPage >= this.totalPage) {
        return false;
      }
      this.currentPage++;
      this.fetchArticles();
    },
    hidePagePicker: function hidePagePicker() {
      this.pagePickerVisible = false;
      this.$refs.pagePicker.hide();
    },
    showPagePicker: function showPagePicker() {
      this.pagePickerVisible = true;
      this.$refs.pagePicker.show();
    },
    pageChanged: function pageChanged(page) {
      this.selectedPage = page.value;
    },
    getSelectedPage: function getSelectedPage() {
      if (!this.$refs.pagePicker.canConfirm()) {
        return;
      }

      this.hidePagePicker();
      this.currentPage = this.selectedPage;
      this.fetchArticles();
    },
    getFirstPage: function getFirstPage() {
      this.hidePagePicker();
      this.currentPage = 1;
      this.fetchArticles();
    },
    getLastPage: function getLastPage() {
      this.hidePagePicker();
      this.currentPage = this.totalPage;
      this.fetchArticles();
    },
    showVote: function showVote() {
      if (!this.mainPost) {
        return false;
      }
      this.showVoteChoice = !this.showVoteChoice;
    },
    voteup: function voteup(article, index) {
      var _this2 = this;

      api.voteup(this.board.name, article.id, { id: article.id }).then(function (res) {
        if (!res.success) {
          return false;
        }
        article.voted = true;
        article.voteddown = false;
        article.voteup_count = res.data.up_count;
        article.votedown_count = res.data.down_count;
        if (index == -1) {
          return _this2.mainPost = article;
        }
        _this2.posts[index] = article;
      });
    },
    votedown: function votedown(article, index) {
      var _this3 = this;

      api.votedown(this.board.name, article.id, { id: article.id }).then(function (res) {
        if (!res.success) {
          return false;
        }
        article.voted = false;
        article.voteddown = true;
        article.voteup_count = res.data.up_count;
        article.votedown_count = res.data.down_count;
        if (index == -1) {
          return _this3.mainPost = article;
        }
        _this3.posts[index] = article;
      });
    },
    votedown_view: function votedown_view(index) {
      var article_dom = document.getElementById(index);
      var username = article_dom.getElementsByClassName("content")[0].getElementsByTagName("h4");
      username[0].style.display = "block";
      username[1].style.display = "none";
      article_dom.getElementsByClassName("article-body")[0].style.display = "block";
      article_dom.getElementsByClassName("a-background")[0].style.display = "none";
    },
    edit: function edit(article) {
      var url = 'type=edit&id=' + article.id + '&board=' + this.board.name;
      this.$router.push('/post?' + url);
    },
    reply: function reply(article) {
      var id = article ? article.id : this.gid;
      var title = encodeURIComponent(this.title);
      var url = 'type=reply&reid=' + id + '&board=' + this.board.name + '&retitle=' + title;
      this.$router.push('/post?' + url);
    }
  }
};

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _home = __webpack_require__(7);

var api = _interopRequireWildcard(_home);

var _Feed = __webpack_require__(41);

var _Feed2 = _interopRequireDefault(_Feed);

var _Slider = __webpack_require__(214);

var _Slider2 = _interopRequireDefault(_Slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
  data: function data() {
    return {
      page: 1,
      isButtonLoading: '',
      isLoading: true,
      banners: [],
      feeds: []
    };
  },


  components: {
    Feed: _Feed2.default,
    Slider: _Slider2.default
  },

  created: function created() {
    this.fetchBanners();
    this.fetchTimeline(this.page);
  },
  mounted: function mounted() {},


  methods: {
    fetchBanners: function fetchBanners() {
      var _this = this;

      api.getBanners().then(function (res) {
        if (!res.success) {
          return false;
        }
        _this.banners = res.data.banners;
      });
    },
    fetchTimeline: function fetchTimeline(page) {
      var _this2 = this;

      this.isLoading = true;
      this.isButtonLoading = 'is-loading';
      api.getTimeline({ page: page }).then(function (res) {
        if (!res.success) {
          return false;
        }
        _this2.feeds = _this2.feeds.concat(res.data.article);
        _this2.isLoading = false;
        _this2.isButtonLoading = '';
      });
    },
    articleLinker: function articleLinker(feed) {
      return "/article/" + feed.board_name + '/' + feed.group_id;
    },
    loadMore: function loadMore() {
      this.fetchTimeline(++this.page);
    }
  }
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Feed = __webpack_require__(41);

var _Feed2 = _interopRequireDefault(_Feed);

var _home = __webpack_require__(7);

var api = _interopRequireWildcard(_home);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isLoading: true,
      topTen: []
    };
  },


  components: {
    Feed: _Feed2.default
  },

  created: function created() {
    this.fetchTopten();
  },


  methods: {
    fetchTopten: function fetchTopten() {
      var _this = this;

      this.isLoading = true;
      api.getTopTen().then(function (res) {
        if (!res.success) {
          return false;
        }
        _this.topTen = res.data;
        _this.isLoading = false;
      });
    },
    jumpToArticle: function jumpToArticle(feed) {
      return '/article/' + feed.board_name + '/' + feed.group_id;
    }
  }
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = __webpack_require__(27);

var _assign2 = _interopRequireDefault(_assign);

var _home = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      isLoading: true,
      profile: {}
    };
  },
  created: function created() {
    this.fetchData();
  },


  methods: {
    fetchData: function fetchData() {
      var _this = this;

      var id = this.$route.params.id;
      (0, _home.getUser)(id).then(function (res) {
        _this.isLoading = false;
        if (!res.success) {
          return _this.$toast('未知用户', {
            callback: function callback() {
              _this.$router.go(-1);
            }
          });
        }

        (0, _assign2.default)(_this.profile, res.data);
      });
    },
    sendMail: function sendMail() {
      this.$router.push({
        name: 'mailSend',
        query: {
          action: 'new',
          to: this.$route.params.id
        }
      });
    },
    addFriend: function addFriend() {
      this.$toast('Ooops, 功能开发中...');
    }
  }
};

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getBoard = undefined;

var _wrapper = __webpack_require__(6);

var getBoard = exports.getBoard = function getBoard(board, params) {
  return (0, _wrapper.get)('board/' + board, params);
};

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.opFav = undefined;

var _wrapper = __webpack_require__(6);

var opFav = exports.opFav = function opFav() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapper.post)('fav/op', params);
};

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEdit = exports.preReply = exports.prePost = exports.editArticle = exports.replyArticle = exports.newArticle = exports.deleteAttachment = exports.addAttachment = undefined;

var _wrapper = __webpack_require__(6);

var addAttachment = exports.addAttachment = function addAttachment(board, file) {
  var articleId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var url = 'attachment/' + board + '/add';
  if (articleId) {
    url += '/' + articleId;
  }

  return (0, _wrapper.post)(url, { file: file });
};

var deleteAttachment = exports.deleteAttachment = function deleteAttachment(board, name) {
  var articleId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var url = 'attachment/' + board + '/delete';
  if (articleId) {
    url += '/' + articleId;
  }

  return (0, _wrapper.post)(url, { name: name });
};

var newArticle = exports.newArticle = function newArticle(board) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _wrapper.post)('article/' + board + '/post', params);
};
var replyArticle = exports.replyArticle = function replyArticle(board, id) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _wrapper.post)('article/' + board + '/post/' + id, params);
};
var editArticle = exports.editArticle = function editArticle(board, id) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _wrapper.post)('article/' + board + '/edit/' + id, params);
};

var prePost = exports.prePost = function prePost(board) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _wrapper.post)('article/' + board + '/prepost', params);
};
var preReply = exports.preReply = function preReply(board, id) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _wrapper.post)('article/' + board + '/prereply/' + id, params);
};
var getEdit = exports.getEdit = function getEdit(board, id) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _wrapper.get)('article/' + board + '/predit/' + id, params);
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRead = exports.getAt = exports.getRefer = undefined;

var _wrapper = __webpack_require__(6);

var getRefer = exports.getRefer = function getRefer(type) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (0, _wrapper.get)('refer/' + type, params);
};

var getAt = exports.getAt = function getAt() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  return (0, _wrapper.get)('refer/at', params);
};

var setRead = exports.setRead = function setRead(type) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return (0, _wrapper.get)('refer/' + type + '/read', params);
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.votedown = exports.voteup = exports.getThread = undefined;

var _wrapper = __webpack_require__(6);

var getThread = exports.getThread = function getThread(board, id, params) {
  return (0, _wrapper.get)('article/' + board + '/' + id, params);
};
var voteup = exports.voteup = function voteup(board, id) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _wrapper.post)('article/' + board + '/voteup/' + id, params);
};
var votedown = exports.votedown = function votedown(board, id) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return (0, _wrapper.post)('article/' + board + '/votedown/' + id, params);
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(16);

var _vue2 = _interopRequireDefault(_vue);

var _axios = __webpack_require__(42);

var _axios2 = _interopRequireDefault(_axios);

var _vuexRouterSync = __webpack_require__(74);

var _App = __webpack_require__(73);

var _App2 = _interopRequireDefault(_App);

var _index = __webpack_require__(43);

var _index2 = _interopRequireDefault(_index);

var _store = __webpack_require__(44);

var _store2 = _interopRequireDefault(_store);

var _toast = __webpack_require__(72);

var _toast2 = _interopRequireDefault(_toast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_toast2.default);

_vue2.default.prototype.$http = _axios2.default;
_vue2.default.prototype.$http.defaults.headers.common = {
  'X-Requested-With': 'XMLHttpRequest'
};

(0, _vuexRouterSync.sync)(_store2.default, _index2.default);

_index2.default.afterEach(function (to, from, next) {
  if (_hmt != false) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/n' + to.fullPath]);
    }
  }
});

var app = new _vue2.default({
  router: _index2.default,
  store: _store2.default,
  beforeCreate: function beforeCreate() {
    var hash = window.location.hash;
    if (hash.startsWith('#!')) {
      var url = '/' + hash.substring(2);
      _index2.default.push(url);
    }
  },
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decreaseRefer = exports.logout = exports.login = undefined;

var _mutationTypes = __webpack_require__(52);

var types = _interopRequireWildcard(_mutationTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var login = exports.login = function login(_ref, user) {
  var commit = _ref.commit;
  return commit(types.LOGIN, user);
};

var logout = exports.logout = function logout(_ref2, user) {
  var commit = _ref2.commit;
  return commit(types.LOGOUT);
};

var decreaseRefer = exports.decreaseRefer = function decreaseRefer(_ref3, type) {
  var commit = _ref3.commit;
  return commit(types.DECREASE_REFER, type);
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.profile = undefined;

var _auth = __webpack_require__(51);

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var profile = function profile(state) {
    return state.auth.user;
};

exports.profile = profile;

/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 179 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 180 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 182 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 184 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 185 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 188 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 189 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 192 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 194 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 196 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 197 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 200 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 202 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(191)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(94),
  /* template */
  __webpack_require__(248),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-755f9026",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(199)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(256),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-bd6451bc",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(202)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(96),
  /* template */
  __webpack_require__(259),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f9371270",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(186)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(243),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-419a681c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(180)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(99),
  /* template */
  __webpack_require__(237),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-21d390e6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(190)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(100),
  /* template */
  __webpack_require__(247),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5c15f9ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(195)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(252),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-84750f22",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(188)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(102),
  /* template */
  __webpack_require__(245),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-58bec95a",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(177)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(103),
  /* template */
  __webpack_require__(234),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0aea14a4",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(189)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(246),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5a6c60ce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(187)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(105),
  /* template */
  __webpack_require__(244),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4e5ed1bd",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(182)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(106),
  /* template */
  __webpack_require__(239),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-333525de",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(185)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(242),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3d57d526",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(200)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(108),
  /* template */
  __webpack_require__(257),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c45d4408",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(194)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(109),
  /* template */
  __webpack_require__(251),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-81178eaa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(196)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(253),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-8ccc5ad6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(181)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(111),
  /* template */
  __webpack_require__(238),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-307f4852",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(197)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(112),
  /* template */
  __webpack_require__(254),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aefcb732",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(183)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(240),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-337ab53e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(193)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(114),
  /* template */
  __webpack_require__(250),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7fa4c8ba",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(198)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(115),
  /* template */
  __webpack_require__(255),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-b4bfcb88",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(192)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(249),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-78caae73",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(117),
  /* template */
  __webpack_require__(233),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(179)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(118),
  /* template */
  __webpack_require__(236),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1903e406",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 233 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "topten"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.topTen), function(feed, index) {
    return _c('div', {
      staticClass: "feeds"
    }, [_c('feed', {
      key: index,
      attrs: {
        "linker": _vm.jumpToArticle(feed),
        "title": feed.title,
        "desciption": feed.content,
        "author": feed.user.id,
        "board": feed.board,
        "attachment": feed.attachment ? feed.attachment : false
      }
    })], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "board"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "container"
  }, [_c('div', {
    staticClass: "board-description"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('content', {
    staticClass: "media-content"
  }, [_c('h4', {
    staticClass: "head"
  }, [_vm._v(" " + _vm._s(_vm.description))])])])]), _vm._v(" "), _c('div', {
    staticClass: "top-posts-section"
  }, _vm._l((_vm.topPosts), function(post, index) {
    return (!index || _vm.showAllTopPosts) ? _c('div', {
      key: post.id,
      staticClass: "top-post"
    }, [_c('span', {
      staticClass: "tag is-warning",
      class: index ? 'invisible' : 'visible'
    }, [_vm._v("置顶")]), _vm._v(" "), _c('router-link', {
      attrs: {
        "target": "_blank",
        "to": _vm.getArticle(post.gid)
      }
    }, [_c('p', [_c('strong', [_vm._v(" " + _vm._s(post.title))])])]), _vm._v(" "), (!index) ? _c('span', {
      staticClass: "more",
      on: {
        "click": function($event) {
          _vm.showAllTopPosts = _vm.showAllTopPosts ? false : true
        }
      }
    }, [_c('i', {
      staticClass: "icon iconfont",
      class: _vm.showAllTopPosts ? 'icon-less' : 'icon-moreunfold'
    })]) : _vm._e()], 1) : _vm._e()
  })), _vm._v(" "), _c('div', {
    staticClass: "posts"
  }, _vm._l((_vm.posts), function(article, index) {
    return _c('div', {
      key: index,
      staticClass: "post"
    }, [_c('router-link', {
      attrs: {
        "target": "_blank",
        "to": _vm.getArticle(article.gid)
      }
    }, [_c('div', {
      staticClass: "poster media"
    }, [_c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('p', [_c('strong', [_vm._v(" " + _vm._s(article.title))])])]), _vm._v(" "), _c('nav', {
      staticClass: "article-footer level is-mobile"
    }, [_c('div', {
      staticClass: "level-left"
    }, [_c('span', {
      staticClass: "level-item"
    }, [_vm._v(_vm._s(article.poster))]), _vm._v(" "), _c('span', {
      staticClass: "level-item"
    }, [_vm._v(" " + _vm._s(article.replyTime) + " 更新")])]), _vm._v(" "), _c('div', {
      staticClass: "level-right"
    }, [_c('span', {
      staticClass: "level-item"
    }, [_vm._v(" " + _vm._s(article.replyCount) + " 人回复")])])])])])]), _vm._v(" "), _c('hr')], 1)
  }))]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "paginate"
  }, [_c('picker', {
    ref: "pagePicker",
    attrs: {
      "data": _vm.pagePickerData
    },
    on: {
      "change": _vm.pageChanged
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "columns is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.hidePagePicker
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getFirstPage
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentPage + '/' + _vm.totalPage))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getLastPage
    }
  }, [_vm._v("末页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getSelectedPage
    }
  }, [_vm._v("确认")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "columns is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getPrevPage
    }
  }, [_vm._v("上一页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.showPagePicker
    }
  }, [_vm._v(_vm._s(_vm.currentPage + '/' + _vm.totalPage))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getNextPage
    }
  }, [_vm._v("下一页")])])])])], 1), _vm._v(" "), _c('float-button', {
    nativeOn: {
      "click": function($event) {
        _vm.newPost()
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 235 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "app-main"
  }, [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content has-text-centered"
  }, [_c('p', [_c('a', {
    attrs: {
      "href": "http://m.byr.cn"
    }
  }, [_vm._v("旧版")]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        _vm.backToNforum()
      }
    }
  }, [_vm._v("电脑版")]), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_vm._v("|")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://bbs.byr.cn/article/Announce/261"
    }
  }, [_vm._v("客户端")])]), _vm._v(" "), _c('p', [_vm._v(" BYR-team@" + _vm._s(_vm.year) + " ")])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "user card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image",
    staticStyle: {
      "height": "100px",
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.profile.face_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.profile.id))])]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v(" " + _vm._s(_vm.profile.user_name) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_c('i', {
    staticClass: "iconfont role icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "role"
  }, [_vm._v(_vm._s(_vm.profile.role))]), _vm._v(" "), (_vm.profile.gender == 'm') ? _c('i', {
    staticClass: "iconfont icon-male",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "iconfont icon-female",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_c('a', {
    staticClass: "button is-outlined is-primary is-small",
    on: {
      "click": function($event) {
        _vm.sendMail()
      }
    }
  }, [_c('i', {
    staticClass: "small iconfont icon-email"
  }), _vm._v("\n                   私信\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "button is-outlined is-info is-small",
    on: {
      "click": function($event) {
        _vm.addFriend()
      }
    }
  }, [_c('i', {
    staticClass: "small iconfont icon-add"
  }), _vm._v("\n                  添加好友\n                ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.life))]), _vm._v(" "), _c('div', [_vm._v("生命力")])]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.post_count) + " ")]), _vm._v(" "), _c('div', [_vm._v(" 文章 ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.score) + " ")]), _vm._v(" "), _c('div', [_vm._v(" 积分 ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "pannel-box"
  }, [_c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" 等级 ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.level) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" 状态 ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.isOnline ? "在线" : "离线") + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" 星座 ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.astro) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" 主页 ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.home_page ? _vm.profile.home_page : '--') + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "basic-info box"
  }, [_c('span', [_vm._v(" QQ ")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.profile.qq ? _vm.profile.qq : '--') + " ")])])])])
},staticRenderFns: []}

/***/ }),
/* 237 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bbssection-card-section"
  }, [_c('div', {
    staticClass: "bbssection"
  }, [_c('div', {
    staticClass: "bbssection-content"
  }, [(_vm.section.dir) ? _c('div', {
    staticClass: "columns is-mobile is-gapless",
    on: {
      "click": function($event) {
        _vm.toggle()
      }
    }
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('div', {
    staticClass: "circle",
    class: _vm.sectionColor(_vm.section.id)
  }, [_c('span', [_vm._v(_vm._s(_vm.section.first_level ? _vm.section.name[0] : _vm.section.name[0]))])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-9"
  }, [_c('div', {
    staticClass: "pull-left section-name section-name-right"
  }, [(!_vm.section.first_level) ? _c('div', [_vm._v("子分区-" + _vm._s(_vm.section.name))]) : _c('div', [_vm._v(_vm._s(_vm.section.name))]), _vm._v(" "), _c('p', {
    staticClass: "title is-6"
  }, [_vm._v(_vm._s(_vm.section.desc))])])]), _vm._v(" "), (!_vm.section.dir) ? _c('div', {
    staticClass: "column is-1 icon-wrapper"
  }, [_c('i', {
    staticClass: "iconfont icon-favorite",
    class: _vm.section.fav ? 'icon-favoritesfilling' : 'icon-favorite'
  })]) : _vm._e()]) : _c('div', {
    staticClass: "columns is-mobile is-gapless",
    staticStyle: {
      "margin-left": "0.5rem"
    }
  }, [_c('div', {
    staticClass: "column is-10",
    on: {
      "click": function($event) {
        _vm.$router.push('/board/' + _vm.section.desc)
      }
    }
  }, [_c('p', {
    staticClass: "title is-6 board-name"
  }, [_vm._v(_vm._s(_vm.section.name))]), _vm._v(" "), _c('p', {
    staticClass: "title is-6"
  }, [_vm._v(_vm._s(_vm.section.desc))])]), _vm._v(" "), (!_vm.section.dir) ? _c('div', {
    staticClass: "column is-2 icon-wrapper"
  }, [_c('i', {
    staticClass: "iconfont icon-favorite",
    class: _vm.section.fav ? 'icon-favoritesfilling' : 'icon-favorite',
    on: {
      "click": function($event) {
        _vm.opFav(_vm.section)
      }
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "children-section"
  }, _vm._l((_vm.section.children), function(child, i) {
    return (_vm.isOpen) ? _c('div', {
      key: child.name,
      staticClass: "children"
    }, [_c('hr'), _vm._v(" "), _c('section-card', {
      attrs: {
        "section": child
      }
    })], 1) : _vm._e()
  }))])
},staticRenderFns: []}

/***/ }),
/* 238 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "post-main"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "标题（必填）"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "说说我的看法吧",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbar card"
  }, [_c('header', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('i', {
    staticClass: "iconfont icon icon-smile",
    on: {
      "click": function($event) {
        _vm.expandSmileBox()
      }
    }
  })]), _vm._v(" "), (_vm.attachment) ? _c('div', {
    staticClass: "column is-2 file-field"
  }, [_c('i', {
    staticClass: "iconfont icon icon-img"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "name": "attachment",
      "id": "attachment"
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('i', {
    staticClass: "iconfont icon icon-at",
    on: {
      "click": function($event) {
        _vm.insertMention()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 post-button",
    class: _vm.attachment ? 'is-offset-5' : 'is-offset-7'
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.post()
      }
    }
  }, [_vm._v("发表")])])])]), _vm._v(" "), (_vm.showSmileBox) ? _c('section', {
    staticClass: "smile-box"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('li', {
    class: _vm.activeSmileSuite == 'em' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('em')
      }
    }
  }, [_c('a', [_vm._v("经典")])]), _vm._v(" "), _c('li', {
    class: _vm.activeSmileSuite == 'ema' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('ema')
      }
    }
  }, [_c('a', [_vm._v("悠嘻猴")])]), _vm._v(" "), _c('li', {
    class: _vm.activeSmileSuite == 'emb' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('emb')
      }
    }
  }, [_c('a', [_vm._v("兔斯基")])]), _vm._v(" "), _c('li', {
    class: _vm.activeSmileSuite == 'emc' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('emc')
      }
    }
  }, [_c('a', [_vm._v("洋葱头")])])])]), _vm._v(" "), _vm._l((_vm.smiles), function(meta) {
    return (meta.name == _vm.activeSmileSuite) ? _c('div', {
      key: meta.name,
      staticClass: "smile-images"
    }, _vm._l((meta.serials), function(i) {
      return _c('figure', {
        key: i,
        class: ("image is-" + (meta.size)),
        on: {
          "click": function($event) {
            _vm.insertSmile(meta.name, i)
          }
        }
      }, [_c('img', {
        attrs: {
          "alt": "",
          "src": ("//bbs.byr.cn/img/ubb/" + (meta.name) + "/" + i + ".gif")
        }
      })])
    })) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.attachment && _vm.showUploadBox) ? _c('section', {
    staticClass: "upload-box"
  }, [_vm._l((_vm.uploadItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "upload-item"
    }, [_c('span', {
      style: ('background-image: url(' + item + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "close-btn",
      on: {
        "click": function($event) {
          _vm.removeImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon iconfont icon-wrong"
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadLoader),
      expression: "showUploadLoader"
    }],
    staticClass: "upload-item"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadItems.length),
      expression: "uploadItems.length"
    }],
    staticClass: "upload-item new-upload"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "name": "attachment",
      "id": "attachment2"
    }
  })])], 2) : _vm._e(), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.pageLoading) ? _c('div', {
    staticClass: "loading-section"
  }, [_vm._m(3)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ball-pulse"
  }, [_c('div'), _c('div'), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-upload-icon"
  }, [_c('i', {
    staticClass: "icon iconfont icon-add"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-tip content"
  }, [_c('blockquote', [_vm._v("未认证手机号的用户请使用电脑版在控制面板处进行手机号验证")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading ball-pulse"
  }, [_c('div'), _c('div'), _c('div')])
}]}

/***/ }),
/* 239 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs is-fullwidth"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.navActived.topten
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navClicked('topten')
      }
    }
  }, [_vm._v("今日十大")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.navActived.timeline
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navClicked('timeline')
      }
    }
  }, [_vm._v("发现")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.navActived.fav
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navClicked('fav')
      }
    }
  }, [_vm._v("版面")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.navActived.profile
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.navClicked('profile')
      }
    }
  }, [_vm._v("我")])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 240 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "reply"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.feeds), function(feed, index) {
    return _c('div', {
      on: {
        "click": function($event) {
          _vm.setRead(feed)
        }
      }
    }, [_c('feed', {
      key: index,
      attrs: {
        "linker": _vm.replyLinker(feed),
        "title": feed.title,
        "desciption": feed.content,
        "author": feed.user,
        "board": feed.board,
        "backgroundColor": feed.read ? 'white' : 'grey',
        "attachment": feed.attachment ? feed.attachment : false
      }
    })], 1)
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 241 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "picker"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "picker-wrapper"
  }, [_c('div', {
    staticClass: "picker-container"
  }, [_c('div', {
    staticClass: "picker-header"
  }, [_vm._t("header")], 2), _vm._v(" "), _c('div', {
    staticClass: "picker-body",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('i', {
    staticClass: "border-bottom-1px"
  }), _vm._v(" "), _c('i', {
    staticClass: "border-top-1px"
  }), _vm._v(" "), _c('div', {
    ref: "pickerWheel",
    staticClass: "picker-wheel"
  }, [_c('ul', {
    staticClass: "wheel-scroll"
  }, _vm._l((_vm.dataItems), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "wheel-item"
    }, [_vm._v(_vm._s(item.label))])
  }))])])])])])
},staticRenderFns: []}

/***/ }),
/* 242 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "tabs is-fullwidth"
  }, [_c('ul', [_c('li', {
    class: {
      'is-active': _vm.mailTabActivated.inbox
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.mailTabClicked('inbox')
      }
    }
  }, [_vm._v("收件箱")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.mailTabActivated.outbox
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.mailTabClicked('outbox')
      }
    }
  }, [_vm._v("发件箱")])]), _vm._v(" "), _c('li', {
    class: {
      'is-active': _vm.mailTabActivated.deleted
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.mailTabClicked('deleted')
      }
    }
  }, [_vm._v("垃圾箱")])])])]), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "float-button-section",
    class: [_vm.visible ? 'fade-in' : 'fade-out']
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float-button"
  }, [_c('span', [_c('i', {
    staticClass: "icon iconfont icon-email"
  })])])
}]}

/***/ }),
/* 244 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "fav-boards"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), (_vm.parent >= 0) ? _c('div', {
    staticClass: "bread-nav"
  }, [_c('a', {
    staticClass: "button is-info is-outlined is-small",
    on: {
      "click": function($event) {
        _vm.getParent()
      }
    }
  }, [_vm._v("返回")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading && _vm.boards.length == 0) ? _c('div', {
    staticClass: "empty-tip"
  }, [_c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v(" 收藏版面空空如也哦 ")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "columns is-multiline is-mobile is-gapless"
  }, [(_vm.level == 0) ? _c('div', {
    staticClass: "column is-half",
    on: {
      "click": function($event) {
        _vm.jumpToSection()
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.boards), function(board, index) {
    return _c('div', {
      key: board.desc + board.level,
      staticClass: "column is-half",
      on: {
        "click": function($event) {
          _vm.jumpToBoard(board)
        }
      }
    }, [_c('div', {
      staticClass: "card fav-board"
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('a', [_c('p', {
      staticClass: "title is-6"
    }, [_vm._v(_vm._s(board.dir ? '[目录]' : '') + " " + _vm._s(board.desc))]), _vm._v(" "), _c('p', {
      staticClass: "sub-title is-6"
    }, [_vm._v("今日" + _vm._s(board.new) + "个讨论")])])])])])
  })], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card fav-board"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('a', [_c('p', {
    staticClass: "title is-6"
  }, [_vm._v("所有版面")]), _vm._v(" "), _c('p', {
    staticClass: "sub-title is-6"
  }, [_vm._v("查找/添加收藏")])])])])
}]}

/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "login"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "main container"
  }, [_vm._m(0), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('form', {
    staticClass: "form"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("用户名")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "username"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("密码")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticClass: "input",
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error),
      expression: "error"
    }],
    staticClass: "help is-danger"
  }, [_vm._v("账户名或者密码错误")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.doLogin
    }
  }, [_vm._v("登录")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header hero is-primary"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns is-vcentered"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("\n                北邮人论坛\n              ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("\n                北邮人温馨的家园\n              ")])])])])])])
}]}

/***/ }),
/* 246 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "contributor-section"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content content"
  }, [_c('h5', [_vm._v("特别感谢")]), _vm._v(" "), _c('ul', _vm._l((_vm.contributors), function(user, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": '/user/' + user.id
      }
    }, [_c('p', [_vm._v(_vm._s(user.id) + " ")])]), _vm._v(" "), _c('p', [_vm._v(_vm._s(user.work))])], 1)
  }))]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item button is-primary",
    attrs: {
      "href": "https://github.com/paper777/yamb"
    }
  }, [_vm._v("参与开发")])])
}]}

/***/ }),
/* 247 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "slider-section",
    style: ({
      width: (_vm.width + "px"),
      height: (_vm.height + "px")
    })
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ready),
      expression: "ready"
    }],
    staticClass: "slider"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      staticClass: "item",
      class: {
        animating: _vm.isAnimating(index),
          active: index == _vm.activeIndex
      },
      style: ({
        transform: ("translateX(" + (_vm.calculatetranslate(index)) + "px)"),
        '-webkit-transform': ("translateX(" + (_vm.calculatetranslate(index)) + "px)"),
        '-moz-transform': ("translateX(" + (_vm.calculatetranslate(index)) + "px)"),
        '-o-transform': ("translateX(" + (_vm.calculatetranslate(index)) + "px)")
      }),
      on: {
        "click": function($event) {
          _vm.clickItem(item)
        }
      }
    }, [_c('figure', [_c('img', {
      attrs: {
        "src": item.image_url
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "focus-item"
  }, [_c('ul', _vm._l((_vm.items), function(item, index) {
    return _c('li', [_c('div', {
      class: {
        active: _vm.activeIndex == index
      }
    })])
  }))])])
},staticRenderFns: []}

/***/ }),
/* 248 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "float-button-section",
    class: [_vm.visible ? 'fade-in' : 'fade-out']
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "float-button"
  }, [_c('span', [_c('i', {
    staticClass: "icon iconfont icon-pen"
  })])])
}]}

/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "timeline"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "banner-field"
  }, [_c('slider', {
    attrs: {
      "items": _vm.banners
    }
  })], 1), _vm._v(" "), _vm._l((_vm.feeds), function(feed, index) {
    return _c('div', {
      staticClass: "feeds"
    }, [_c('feed', {
      key: index,
      attrs: {
        "linker": _vm.articleLinker(feed),
        "title": feed.title,
        "desciption": feed.content,
        "author": feed.user.id,
        "board": feed.board,
        "attachment": feed.attachment ? feed.attachment : false
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "load-more card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('a', {
    class: 'card-header-title button is-primary ' + _vm.isButtonLoading,
    on: {
      "click": function($event) {
        _vm.loadMore()
      }
    }
  }, [_vm._v("加载更多...")])])])], 2)
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Section board-list"
  }, [_c('div', {
    staticClass: "columns is-multiline is-mobile is-gapless search"
  }, [_c('div', {
    staticClass: "column is-12"
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.searchBoard($event)
      }
    }
  }, [_c('p', {
    staticClass: "control has-icons-left"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search_content),
      expression: "search_content"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "查找版面"
    },
    domProps: {
      "value": (_vm.search_content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search_content = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.boards), function(section, i) {
    return _c('section-card', {
      key: section.name,
      attrs: {
        "section": section
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small is-left"
  }, [_c('i', {
    staticClass: "iconfont icon-search"
  })])
}]}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "maillist"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', _vm._l((_vm.mails), function(mail, index) {
    return _c('div', {
      key: index,
      staticClass: "mails"
    }, [_c('mail-item', {
      attrs: {
        "read": mail.read,
        "num": mail.num,
        "sender": mail.sender,
        "title": mail.title,
        "time": mail.time,
        "size": mail.size,
        "linker": _vm.mailLinker(mail)
      }
    })], 1)
  })), _vm._v(" "), (!_vm.isLoading) ? _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "columns is-mobile pagination"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    class: {
      disabled: _vm.isFirstPage
    },
    on: {
      "click": function($event) {
        _vm.changePage(1)
      }
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    class: {
      disabled: _vm.isFirstPage
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage - 1)
      }
    }
  }, [_vm._v("上页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v(_vm._s((_vm.currentPage + "/" + _vm.totalPage)))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    class: {
      disabled: _vm.isLastPage
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.currentPage + 1)
      }
    }
  }, [_vm._v("下页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    class: {
      disabled: _vm.isLastPage
    },
    on: {
      "click": function($event) {
        _vm.changePage(_vm.totalPage)
      }
    }
  }, [_vm._v("末页")])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "toast-section"
  }, [_c('div', {
    staticClass: "toast",
    class: [_vm.visible ? 'fade-in' : 'fade-out']
  }, [_c('p', [_vm._v(_vm._s(_vm.message))])])])
},staticRenderFns: []}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "post-main"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "标题（必填）"
    },
    domProps: {
      "value": (_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input to"
  }, [_vm._v("To: " + _vm._s(_vm.to))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "textarea",
    attrs: {
      "placeholder": "写下你想对TA说什么吧",
      "rows": "10"
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "toolbar card"
  }, [_c('header', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-2"
  }, [_c('i', {
    staticClass: "iconfont icon icon-smile",
    on: {
      "click": function($event) {
        _vm.expandSmileBox()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "column is-2 post-button is-offset-7"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.onSend()
      }
    }
  }, [_vm._v("发送")])])])]), _vm._v(" "), (_vm.showSmileBox) ? _c('section', {
    staticClass: "smile-box"
  }, [_c('div', {
    staticClass: "tabs"
  }, [_c('ul', [_c('li', {
    class: _vm.activeSmileSuite == 'em' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('em')
      }
    }
  }, [_c('a', [_vm._v("经典")])]), _vm._v(" "), _c('li', {
    class: _vm.activeSmileSuite == 'ema' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('ema')
      }
    }
  }, [_c('a', [_vm._v("悠嘻猴")])]), _vm._v(" "), _c('li', {
    class: _vm.activeSmileSuite == 'emb' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('emb')
      }
    }
  }, [_c('a', [_vm._v("兔斯基")])]), _vm._v(" "), _c('li', {
    class: _vm.activeSmileSuite == 'emc' ? 'is-active' : '',
    on: {
      "click": function($event) {
        _vm.clickSmileSuite('emc')
      }
    }
  }, [_c('a', [_vm._v("洋葱头")])])])]), _vm._v(" "), _vm._l((_vm.smiles), function(meta) {
    return (meta.name == _vm.activeSmileSuite) ? _c('div', {
      key: meta.name,
      staticClass: "smile-images"
    }, _vm._l((meta.serials), function(i) {
      return _c('figure', {
        key: i,
        class: ("image is-" + (meta.size)),
        on: {
          "click": function($event) {
            _vm.insertSmile(meta.name, i)
          }
        }
      }, [_c('img', {
        attrs: {
          "alt": "",
          "src": ("//bbs.byr.cn/img/ubb/" + (meta.name) + "/" + i + ".gif")
        }
      })])
    })) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), (_vm.attachment && _vm.showUploadBox) ? _c('section', {
    staticClass: "upload-box"
  }, [_vm._l((_vm.uploadItems), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "upload-item"
    }, [_c('span', {
      style: ('background-image: url(' + item + ')')
    }), _vm._v(" "), _c('div', {
      staticClass: "close-btn",
      on: {
        "click": function($event) {
          _vm.removeImage(index)
        }
      }
    }, [_c('i', {
      staticClass: "icon iconfont icon-wrong"
    })])])
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showUploadLoader),
      expression: "showUploadLoader"
    }],
    staticClass: "upload-item"
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.uploadItems.length),
      expression: "uploadItems.length"
    }],
    staticClass: "upload-item new-upload"
  }, [_vm._m(1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "accept": "image/*",
      "name": "attachment",
      "id": "attachment2"
    }
  })])], 2) : _vm._e(), _vm._v(" "), (_vm.pageLoading) ? _c('div', {
    staticClass: "loading-section"
  }, [_vm._m(2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "new-upload-icon"
  }, [_c('i', {
    staticClass: "icon iconfont icon-add"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')])
}]}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "profile"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "user card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image",
    staticStyle: {
      "height": "100px",
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.profile.face_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_c('strong', [_vm._v(_vm._s(_vm.profile.id))])]), _vm._v(" "), _c('div', {
    staticClass: "items"
  }, [_c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v(" " + _vm._s(_vm.profile.user_name) + " ")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_c('i', {
    staticClass: "iconfont role icon-account",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "role"
  }, [_vm._v(_vm._s(_vm.profile.role))]), _vm._v(" "), (_vm.profile.gender == 'm') ? _c('i', {
    staticClass: "iconfont icon-male",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _c('i', {
    staticClass: "iconfont icon-female",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.life))]), _vm._v(" "), _c('div', [_vm._v("生命力")])]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.post_count) + " ")]), _vm._v(" "), _c('div', [_vm._v(" 文章 ")])]), _vm._v(" "), _c('a', {
    staticClass: "card-footer-item"
  }, [_c('div', [_vm._v(" " + _vm._s(_vm.profile.score) + " ")]), _vm._v(" "), _c('div', [_vm._v(" 积分 ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "pannel-box"
  }, [_c('div', {
    staticClass: "mail box",
    on: {
      "click": function($event) {
        _vm.$router.push('/reply')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-remind"
  }), _vm._v(" \n      "), _c('span', [_vm._v(" 回复我的 ")]), (_vm.profile.new_reply) ? _c('span', {
    staticClass: "tag is-warning"
  }, [_vm._v(_vm._s(_vm.profile.new_reply))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "reply box",
    on: {
      "click": function($event) {
        _vm.$router.push('/at')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-at"
  }), _vm._v(" \n      "), _c('span', [_vm._v(" 提到我的 ")]), (_vm.profile.new_at) ? _c('span', {
    staticClass: "tag is-warning"
  }, [_vm._v(_vm._s(_vm.profile.new_at))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "refer box",
    on: {
      "click": function($event) {
        _vm.$router.push('/mail/inbox')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-email"
  }), _vm._v(" \n      "), _c('span', [_vm._v(" 收件箱 ")]), _vm._v(" "), (_vm.profile.new_mail) ? _c('span', {
    staticClass: "tag is-warning"
  }, [_vm._v("新")]) : _vm._e(), _vm._v(" "), (_vm.profile.full_mail) ? _c('span', {
    staticClass: "tag is-danger"
  }, [_vm._v("满")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "pannel-box infomations"
  }, [_c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        _vm.$router.push('/post?type=new&board=advice')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-edit"
  }), _vm._v(" \n      "), _c('span', [_vm._v("意见反馈")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        _vm.$router.push('/article/id/9272')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-attachment"
  }), _vm._v(" \n      "), _c('span', [_vm._v("论坛管理办法")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        _vm.$router.push('/contributor')
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-smile"
  }), _vm._v(" \n      "), _c('span', [_vm._v(" 特别感谢 ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "pannel-box",
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_c('div', {
    staticClass: "box",
    on: {
      "click": _vm.getLogout
    }
  }, [_c('span', [_vm._v(" 退出登录 ")])])])])
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "thread"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentPage == 1),
      expression: "currentPage == 1"
    }],
    staticClass: "thread-header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('div', {
    staticClass: "columns is-mobile"
  }, [_c('div', {
    staticClass: "column is-7"
  }, [_c('small', [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.jumpToBoard(_vm.board.name)
      }
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.board.description + '/' + _vm.board.name))])])])]), _vm._v(" "), _c('hr')]), _vm._v(" "), (_vm.mainPost && _vm.currentPage == 1) ? _c('div', {
    staticClass: "article"
  }, [_c('div', {
    staticClass: "poster media"
  }, [_c('figure', {
    staticClass: "media-left"
  }, [_c('p', {
    staticClass: "image is-32x32",
    on: {
      "click": function($event) {
        _vm.jumpToUser(_vm.mainPost)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.mainPost.poster.face_url
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "media-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', {
    class: [_vm.mainPost.poster.gender == 'm' ? 'gender-m' : 'gender-f'],
    on: {
      "click": function($event) {
        _vm.jumpToUser(_vm.mainPost)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.mainPost.poster.id))]), _vm._v(" "), _c('small', [_c('span', [_vm._v("楼主")]), _vm._v(" " + _vm._s(_vm.mainPost.time) + " ")])])]), _vm._v(" "), _c('div', {
    staticClass: "media-right"
  }, [_c('span', [(_vm.mainPost && _vm.mainPost.op) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.edit(_vm.mainPost)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-edit"
  })]) : _vm._e()]), _vm._v(" "), _c('span', [_c('a', {
    on: {
      "click": function($event) {
        _vm.reply(_vm.mainPost)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-comments"
  })])]), _vm._v(" "), (_vm.mainPost) ? _c('span', [(!_vm.mainPost.voted) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.voteup(_vm.mainPost, -1)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-good"
  })]) : _c('i', {
    staticClass: "iconfont icon-good voted"
  }), _vm._v("\n              " + _vm._s(_vm.mainPost.voteup_count) + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.mainPost) ? _c('span', [(!_vm.mainPost.voteddown) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.votedown(_vm.mainPost, -1)
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-bad"
  })]) : _c('i', {
    staticClass: "iconfont icon-bad voted"
  }), _vm._v("\n              " + _vm._s(_vm.mainPost.votedown_count) + "\n            ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "article-body content",
    domProps: {
      "innerHTML": _vm._s(_vm.mainPost.content)
    }
  })]) : (!_vm.mainPost) ? _c('div', {
    staticClass: "oops"
  }, [_c('span', [_vm._v("O0o0Ops...内容不见了")]), _vm._v(" "), _c('hr')]) : _vm._e(), _vm._v(" "), (_vm.currentPage == 1 && _vm.popularReplies.length) ? _c('div', {
    staticClass: "popular-replies"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.popularReplies), function(article, index) {
    return _c('div', {
      key: index,
      staticClass: "post"
    }, [_c('div', {
      staticClass: "poster media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-32x32",
      on: {
        "click": function($event) {
          _vm.jumpToUser(article)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": article.poster ? article.poster.face_url : ''
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('h4', {
      class: [article.poster ? (article.poster.gender == 'm' ? 'gender-m' : 'gender-f') : 'gender-u'],
      on: {
        "click": function($event) {
          _vm.jumpToUser(article)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(article.poster ? article.poster.id : '已注销'))]), _vm._v(" "), _c('small', [_c('span', [_vm._v(_vm._s(article.pos == 1 ? '沙发' : (article.pos == 2 ? '板凳' : article.pos + '楼')))]), _vm._v("\n                  " + _vm._s(article.time) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [_c('span', [(_vm.mainPost && _vm.mainPost.op) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.edit(_vm.mainPost)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-edit"
    })]) : _vm._e()]), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          _vm.reply(_vm.mainPost)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-comments"
    })])]), _vm._v(" "), _c('span', [(!article.voted) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.voteup(article, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-good"
    })]) : _c('i', {
      staticClass: "iconfont icon-good voted"
    }), _vm._v("\n                " + _vm._s(article.voteup_count) + "\n              ")]), _vm._v(" "), _c('span', [(!article.voteddown) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.votedown(article, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bad"
    })]) : _c('i', {
      staticClass: "iconfont icon-bad voted"
    }), _vm._v("\n                " + _vm._s(article.votedown_count) + "\n              ")])])]), _vm._v(" "), _c('div', {
      staticClass: "article-body content",
      domProps: {
        "innerHTML": _vm._s(article.content)
      }
    }), _vm._v(" "), (index < _vm.popularReplies.length - 1) ? _c('hr') : _vm._e()])
  })], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "posts"
  }, [(_vm.currentPage == 1 && _vm.posts.length) ? _c('div', {
    staticClass: "reply-tag"
  }, [_c('span', {
    staticClass: "tag is-primary"
  }, [_vm._v("全部回复")]), _vm._v(" "), _c('b')]) : _vm._e(), _vm._v(" "), _vm._l((_vm.posts), function(article, index) {
    return _c('div', {
      key: index,
      staticClass: "post",
      attrs: {
        "id": article.pos
      }
    }, [_c('div', {
      staticClass: "poster media"
    }, [_c('figure', {
      staticClass: "media-left"
    }, [_c('p', {
      staticClass: "image is-32x32",
      on: {
        "click": function($event) {
          _vm.jumpToUser(article)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": article.poster ? article.poster.face_url : ''
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "media-content"
    }, [_c('div', {
      staticClass: "content"
    }, [_c('h4', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.votedown_count - article.voteup_count < article.votedown_min),
        expression: "article.votedown_count - article.voteup_count < article.votedown_min"
      }],
      class: [article.poster ? (article.poster.gender == 'm' ? 'gender-m' : 'gender-f') : 'gender-u'],
      on: {
        "click": function($event) {
          _vm.jumpToUser(article)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(article.poster ? article.poster.id : '已注销'))]), _vm._v(" "), _c('small', [_c('h4', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.votedown_count - article.voteup_count >= article.votedown_min),
        expression: "article.votedown_count - article.voteup_count >= article.votedown_min"
      }],
      class: [article.poster ? (article.poster.gender == 'm' ? 'gender-m' : 'gender-f') : 'gender-u']
    }, [_vm._v("****")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(article.pos == 1 ? '沙发' : article.pos == 2 ? '板凳' : article.pos + '楼'))]), _vm._v("\n                  " + _vm._s(article.time) + "\n                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "media-right"
    }, [_c('span', [(_vm.mainPost && _vm.mainPost.op) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.edit(article)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-edit"
    })]) : _vm._e()]), _vm._v(" "), _c('span', [_c('a', {
      on: {
        "click": function($event) {
          _vm.reply(article)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-comments"
    })])]), _vm._v(" "), _c('span', [(!article.voted) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.voteup(article, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-good"
    })]) : _c('i', {
      staticClass: "iconfont icon-good voted"
    }), _vm._v("\n                " + _vm._s(article.voteup_count) + "\n              ")]), _vm._v(" "), _c('span', [(!article.voteddown) ? _c('a', {
      on: {
        "click": function($event) {
          _vm.votedown(article, index)
        }
      }
    }, [_c('i', {
      staticClass: "iconfont icon-bad"
    })]) : _c('i', {
      staticClass: "iconfont icon-bad voted"
    }), _vm._v("\n                " + _vm._s(article.votedown_count) + "\n              ")])])]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.votedown_count - article.voteup_count < article.votedown_min),
        expression: "article.votedown_count - article.voteup_count < article.votedown_min"
      }],
      staticClass: "article-body content",
      class: {
        'selected-content': article.pos == _vm.position, 'remove-selected': _vm.removeSelected
      },
      domProps: {
        "innerHTML": _vm._s(article.content)
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (article.votedown_count - article.voteup_count >= article.votedown_min),
        expression: "article.votedown_count - article.voteup_count >= article.votedown_min"
      }],
      staticClass: "a-background"
    }, [_c('p', [_vm._v("此楼踩的人太多已被折叠。")]), _vm._v(" "), _c('p', [_vm._v("请多多注意自己的发言哦...")]), _vm._v(" "), _c('a', {
      staticClass: "a-func-dispCai button",
      on: {
        "click": function($event) {
          _vm.votedown_view(article.pos)
        }
      }
    }, [_vm._v("手贱想看")])]), _vm._v(" "), _c('hr')])
  })], 2)])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "! isLoading"
    }],
    staticClass: "paginate"
  }, [_c('picker', {
    ref: "pagePicker",
    attrs: {
      "data": _vm.pagePickerData
    },
    on: {
      "change": _vm.pageChanged
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "columns is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.hidePagePicker
    }
  }, [_vm._v("取消")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getFirstPage
    }
  }, [_vm._v("首页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', [_vm._v(_vm._s(_vm.currentPage + '/' + _vm.totalPage))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getLastPage
    }
  }, [_vm._v("末页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getSelectedPage
    }
  }, [_vm._v("确认")])])])])])]), _vm._v(" "), (_vm.mainPost) ? [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showVoteChoice),
      expression: "showVoteChoice"
    }],
    staticClass: "card",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('header', {
    staticClass: "columns  is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [(_vm.mainPost && !_vm.mainPost.voted) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.voteup(_vm.mainPost, -1);
        _vm.showVote();
      }
    }
  }, [_vm._v("赞 " + _vm._s(_vm.mainPost.voteup_count))]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.showVote()
      }
    }
  }, [_vm._v("赞 " + _vm._s(_vm.mainPost.voteup_count))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [(_vm.mainPost && !_vm.mainPost.voteddown) ? _c('a', {
    on: {
      "click": function($event) {
        _vm.votedown(_vm.mainPost, -1);
        _vm.showVote();
      }
    }
  }, [_vm._v("踩 " + _vm._s(_vm.mainPost.votedown_count))]) : _c('a', {
    on: {
      "click": function($event) {
        _vm.showVote()
      }
    }
  }, [_vm._v("踩 " + _vm._s(_vm.mainPost.votedown_count))])])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "columns is-mobile paginate-items"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.showVote
    }
  }, [_vm._m(1), _vm._v("\n            赞 " + _vm._s(_vm.mainPost ? _vm.mainPost.voteup_count : '0') + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getPrevPage
    }
  }, [_vm._v("上页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.showPagePicker
    }
  }, [_vm._v(_vm._s(_vm.currentPage + '/' + _vm.totalPage))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": _vm.getNextPage
    }
  }, [_vm._v("下页")])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.reply(_vm.mainPost)
      }
    }
  }, [_vm._v("回复")])])])])], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "reply-tag"
  }, [_c('span', {
    staticClass: "tag is-danger"
  }, [_vm._v("精彩回复")]), _vm._v(" "), _c('b')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "iconfont icon-less up"
  }), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-moreunfold down"
  })])
}]}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    attrs: {
      "to": _vm.linker
    }
  }, [_c('section', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "mail-list-item"
  }, [_c('h4', {
    staticClass: "title is-4",
    class: {
      notRead: !_vm.read, hasRead: _vm.read
    }
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "inscribe"
  }, [_c('span', {
    staticClass: "is-pulled-left"
  }, [_vm._v("from  " + _vm._s(_vm.sender))]), _vm._v("\n         \n        "), _c('span', {
    staticClass: "is-pulled-right"
  }, [_vm._v(_vm._s(_vm.time))])])])])])
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "page-loading loader-inner ball-pulse"
  }, [_c('div'), _vm._v(" "), _c('div'), _vm._v(" "), _c('div')]) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.error) ? _c('div', {
    staticClass: "mail"
  }, [_c('div', {
    staticClass: "mail-title"
  }, [_c('h4', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.mail.title))])]), _vm._v(" "), _c('div', {
    staticClass: "mail-inscribe"
  }, [_c('span', {
    staticClass: "sender is-pulled-left"
  }, [_vm._v("from:  " + _vm._s(_vm.mail.sender))]), _vm._v(" "), _c('span', {
    staticClass: "time is-pulled-right"
  }, [_vm._v(_vm._s(_vm.mail.time))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "mail-content"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.mail.content)
    }
  })])]) : _c('div', {
    staticClass: "error"
  }, [_c('div', [_vm._v("Oops, there is an error...")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.errorMessage))])])]), _vm._v(" "), (this.mailType !== 'deleted' && !_vm.error) ? _c('div', [_c('float-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.reply($event)
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "main",
    attrs: {
      "target": "_blank",
      "to": _vm.linker
    }
  }, [_c('section', {
    class: 'feed box ' + _vm.backgroundColor
  }, [_c('div', {
    staticClass: "feed-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h4', {
    staticClass: "title is-4"
  }, [_vm._t("header", [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")])], 2), _vm._v(" "), _c('div', {
    staticClass: "media"
  }, [_c('p', {
    staticClass: "media-content"
  }, [_vm._v("\n            " + _vm._s(_vm.desciption) + "\n          ")]), _vm._v(" "), (_vm.attachment) ? _c('div', {
    staticClass: "cover media-right"
  }, [_c('img', {
    staticClass: "image is-64x64",
    attrs: {
      "src": _vm.attachment
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_vm._v("\n        by "), _c('span', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.author))]), _vm._v("\n        from "), _c('span', {
    staticClass: "board"
  }, [_vm._v(_vm._s(_vm.board))])])])])])
},staticRenderFns: []}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-primary"
  }, [_c('div', {}, [_c('header', {
    staticClass: "nav"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('h3', {
    staticClass: "title is-6",
    on: {
      "click": function($event) {
        _vm.$router.push('/home/topten')
      }
    }
  }, [_vm._v("北邮人论坛")])])]), _vm._v(" "), _vm._m(0)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav-center"
  }, [_c('div', {
    staticClass: "nav-item"
  })])
}]}

/***/ })
],[124]);


// WEBPACK FOOTER //
// yamb/js/app.9a7f6447b71db8f2c543.js